export default __webpack_public_path__ + "static/media/24.cbef7acf.jpg";